import { useMemo } from 'react';
import type { TenantSelectorRowData } from './types';
import { useTenants } from './useTenants';

/**
 * Callers must pass a referentially stable `rowDataByTenantId` (e.g. via
 * `useMemo`) so the dependency array triggers correctly.
 */
export function useTenantSelectorRowData(
  rowDataByTenantId: Record<string, Partial<TenantSelectorRowData>>,
): { tenantRowData: Record<string, TenantSelectorRowData>; isLoading: boolean } {
  const { data: tenants = [], isLoading } = useTenants();

  const tenantRowData = useMemo(() => {
    const map: Record<string, TenantSelectorRowData> = {};
    for (const t of tenants) {
      map[t.id] = { name: t.name, ...rowDataByTenantId[t.id] };
    }
    return map;
  }, [tenants, rowDataByTenantId]);

  return { tenantRowData, isLoading };
}
